import styled from 'styled-components';
import {themeGet} from '@styled-system/theme-get';

export const PostWrapper = styled.div`
  position: relative;
  @media (min-width: 400px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .preview-container {
    @media (min-width: 400px) {
      flex: 0 0 42%;
      max-width: 400px;
      padding-right: 60px;
    }
  }

  //margin-bottom: 100px;

  .post-des-wrapper-high {
    @media (min-width: 400px) {
      flex: 0 0 58%;
      max-width: 58%;
    }

    .post-des {
      margin-top: 40px;
    }
  }
`;


export const ThumbnailWrapper = styled.div`
  margin-right: 20px;
  width: 64px;
  height: 64px;
  position: relative;
  @media (max-width: 524px) {
    margin-right: 10px;
  }

  .gatsby-image-wrapper {
    border-radius: 6px;
    height: 100%;
  }
`

export const HorizontalSeparator = styled.div`
  &:after {
    content: '';
    width: 30px;
    height: 1em;
    display: block;
    background: ${({theme}) => theme.foreground};
  }
`;

export const PostTitle = styled.h1`
  font-size: 30px;
  font-weight: 700;
  color: ${({theme}) => theme.semiforeground};
  line-height: 1.53;
  margin-bottom: 10px;
`;

// export const PostDate = styled.span`
//   //display: block;
//   margin-right: 20px;
//   font-size: ${themeGet('fontSizes.3', '15')}px;
//   color: ${({theme}) => theme.foreground};
//   font-weight: 400;
//   text-transform: uppercase;
//   @media (max-width: 780px) {
//     font-size: 14px;
//   }
//   @media (max-width: 400px) {
//     font-size: 13px;
//   }
// `;

export const PostHeaderImage = styled.div`
  //margin-top: 45px;
  //margin-bottom: 40px;
  position: relative;
  //@media (max-width: 1200px) {
  //  margin-top: 40px;
  //}
  @media (max-width: 400px) {
    margin-bottom: 30px;
  }

  img {
    border-radius: 6px;
  }

  &:before {
    content: '';
    position: absolute;
    width: 80%;
    height: 80%;
    background-color: ${({theme}) => theme.shadow};
    //transition: background-color .3s ease-in;
    bottom: 0;
    left: 10%;
    filter: blur(15px);
  }

  //.svg-wrapper {
  //  padding-top: 100%;
  //}
`;

export const PostHeaderContent = styled.div`
  display: grid;
  align-content: space-between;
  margin: 0 auto 10px auto;
  width: 870px;
  max-width: 100%;

  img {
    width: 100%;
    display: block;
    margin: 0 auto 1em auto;
  }

  p > span svg.tinysvg {
    display: inline-block;
    width: 1em;
    height: auto;
    cursor: pointer;

    rect {
        // fill: ${({theme}) => theme.text};
      @media (hover: hover) {
        :hover {
          transition: fill 0.2s;
          fill: ${themeGet('colors.primary', '#2251ff')}; /* Change color on hover */
        }
      }
    }

    path {
      fill: ${({theme}) => theme.body};
    }
  }
`;

export const PostText = styled.div`
  overflow: hidden;
  font-size: ${themeGet('fontSizes.3', '15')}px;

  .mermaid {
    margin-bottom: 60px;
    @media (max-width: 767px) {
      margin-bottom: 40px;
    }
  }

  img, video {
    border-radius: 6px;
  }

  .side-by-side {
    // For displaying to images side by side, until they dont
    // fit anymore and go below one another
    column-gap: 5%;
    display: grid;
    justify-items: center;
    grid-template-columns: 1fr 1fr;
    @media (min-width: 600px) {
      grid-template-columns: repeat(2, 1fr);
    }
    span.gatsby-resp-image-wrapper {
      width: 100%;
      margin: 0 !important;
    }
  }
    
  .grid {
    column-gap: 5%;
    display: grid;
    justify-items: center;
    text-align: center;
    @media (min-width: 600px) {
      grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    }
    //span.gatsby-resp-image-wrapper {
    span {
      width: 100%;
      margin: 0 !important;
    }
    margin-bottom: 1em;

  }

  iframe {
    height: 256px;
    display: block;
    margin-top: 1.7em;
    margin-bottom: 1.7em;

    border: none;
    overflow: hidden;
    border-radius: 6px;
    width: 100%;
  }

  div.mermaid {
    display: flex;
    align-content: center;
    flex-direction: column;
    flex-wrap: wrap;
  }

  a.anchor {
    display: block;
    position: relative;
    visibility: hidden;
    top: -91px;
    @media (max-width: 1200px) {
      top: -101px;
    }
    @media (max-width: 990px) {
      top: -78px;
    }
    @media (max-width: 575px) {
      top: -54px;
    }
    @media (max-width: 385px) {
      top: -51px;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 500;
    margin-bottom: 0.25em;
  }

  h1 {
    font-size: 30px;
  }

  h2 {
    font-size: 25px;
  }

  h3 {
    font-size: 21px;
  }

  h4 {
    font-size: 17px;
  }

  h5 {
    font-size: 15px;
  }

  h6 {
    font-size: 13px;
  }

  ol,
  ul {
    margin-left: 1.5rem;
    margin-bottom: 2rem;
    line-height: 2;
  }

  li {
    margin-bottom: 0.45rem;
  }

  blockquote {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;

    ul {
      line-height: 1;

      li {
        margin-bottom: 1rem;
      }
    }

    h1 {
      font-size: 22px;
    }

    //line-height: 2; 
    //margin: 60px 0;
    margin: 30px 20px;
    padding: 0 40px;
    background-color: ${({theme}) => theme.semibackground};
    border-radius: 6px;
    //@media (max-width: 1200px) {
    //  margin: 50px 0;
    //  font-size: 19px;
    //}
    //@media (max-width: 400px) {
    //  font-size: 16px;
    //}
    @media (max-width: 780px) {
      margin: 20px 0;
    }

    &:before,
    &:after {
      content: '';
      width: 30px;
      height: 1px;
      display: block;
      background: ${({theme}) => theme.foreground};
    }

    //}
    &:before {
      margin-bottom: 2rem;
    }

    &:after {
      margin-top: 2rem;
    }

    //&:before {
    //  margin-bottom: 60px;
    //  @media (max-width: 1200px) {
    //    margin-bottom: 50px;
    //  }
    //  @media (max-width: 575px) {
    //    margin-bottom: 40px;
    //  }
    //}
    //&:after {
    //  margin-top: 60px;
    //  @media (max-width: 1200px) {
    //    margin-top: 50px;
    //  }
    //  @media (max-width: 575px) {
    //    margin-top: 40px;
    //  }
    //}

    p {
      font-weight: 500;
      line-height: 2;
      margin-bottom: 23px;
      @media (max-width: 1200px) {
        font-size: 19px;
      }
      @media (max-width: 1200px) {
        font-size: 17px;
      }
      @media (max-width: 575px) {
        font-size: 15px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    h4 {
      font-size: 16px;
      margin: 0;
      font-family: 'Fira Sans', sans-serif;
      font-weight: 400;
    }
  }

  a {
    font-weight: 500;
    transition: 0.15s ease-in-out;
    color: ${themeGet('primary', '#2251ff')};
  }

  // Custom classes, please note where this class applies to!
    
  // This animation applies to the six frames on the Picomino page  
  .animation {
    position: relative;
    max-width: 600px;
    margin: auto;
  }

  //@formatter:off
  .animation img {
    position: absolute;
    visibility: hidden;
    &.cycle6-1 {animation: cycle6-key1 9s infinite;}
    &.cycle6-2 {animation: cycle6-key2 9s infinite;}
    &.cycle6-3 {animation: cycle6-key3 9s infinite;}
    &.cycle6-4 {animation: cycle6-key4 9s infinite;}
    &.cycle6-5 {animation: cycle6-key5 9s infinite;}
    &.cycle6-6 {animation: cycle6-key6 9s infinite;}
    &.cycle6-6 {
         position: inherit;
    }
    @keyframes cycle6-key1 {0%, 16.67% {visibility: visible;} 16.68%, 100.0% {visibility: hidden;}}
    @keyframes cycle6-key2 {0%, 16.67% {visibility: hidden;} 16.68%, 33.33% {visibility: visible;} 33.33%, 100% {visibility: hidden;}}
    @keyframes cycle6-key3 {0%, 33.33% {visibility: hidden;} 33.34%, 50.00% {visibility: visible;} 50.00%, 100% {visibility: hidden;}}
    @keyframes cycle6-key4 {0%, 50.00% {visibility: hidden;} 50.01%, 66.67% {visibility: visible;} 66.67%, 100% {visibility: hidden;}}
    @keyframes cycle6-key5 {0%, 66.67% {visibility: hidden;} 66.68%, 83.33% {visibility: visible;} 83.33%, 100% {visibility: hidden;}}
    @keyframes cycle6-key6 {0%, 83.33% {visibility: hidden;} 83.34%, 100.0% {visibility: visible;}}
  }
  //@formatter:on

`;

export const PostTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  //margin-top: 60px;

  a {
    display: block;
    margin-right: 20px;
    font-size: 14px;
    font-weight: 400;
    color: ${themeGet('primary', '#2251ff')};
  }
`;
